import { FC } from 'react';
import { useSetAtom } from 'jotai';
import { useTranslation } from 'next-i18next';
import Template from 'src/components/AzarOnly/Login/Steps/Template';
import useHelpCenterUrl from 'src/hooks/useHelpCenterUrl';
import { isRemoveOldDeviceUserDetailsAtom, pushPhoneNumberLoginHistoryAtom } from 'src/stores/phoneNumberLogin/atoms';
import { resetRegisterAtom } from 'src/stores/register/atoms';
import EmailAddressRegisterStep from './EmailAddressRegisterStep';
const NotExistEmailStep: FC = () => {
  const helpCenterUrl = useHelpCenterUrl();
  const resetRegister = useSetAtom(resetRegisterAtom);
  const setRemoveOldDeviceUserDetails = useSetAtom(isRemoveOldDeviceUserDetailsAtom);
  const pushHistory = useSetAtom(pushPhoneNumberLoginHistoryAtom);

  // 기존 PhoneNumber 계정 삭제하고, 동일 PhoneNumber로 새 계정 생성
  const handleMainClick = () => {
    setRemoveOldDeviceUserDetails(true);
    pushHistory(<EmailAddressRegisterStep />);
  };

  // PhoneNumber 말고 다른 방법으로 로그인
  const handleSubClick = () => {
    resetRegister();
  };
  const {
    t
  } = useTranslation();
  return <Template eventId='signup_phone_not_verified_title' title={t('signup_phone_not_verified_title')} description={t('signup_phone_not_verified_desc')} link={helpCenterUrl} mainButtonProps={{
    onClick: handleMainClick,
    text: t('signup_phone_btn_reg')
  }} subButtonProps={{
    onClick: handleSubClick,
    text: t('signup_phone_btn_other_methods')
  }} linkText={t('signup_phone_btn_helpcenter')} data-sentry-element="Template" data-sentry-component="NotExistEmailStep" data-sentry-source-file="NotExistEmailStep.tsx" />;
};
export default NotExistEmailStep;